import { Dispatch } from '@reduxjs/toolkit';
import { CmcWebApi, IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { ACCOUNT_STORE_NAME, actions, IStore } from './store';
import { AccountKey, CmcWebApiAccountHoldingLeanModel1 } from './types';
import { frontendActions, getConfig, LocationType, ResourceKey } from '@cmctechnology/webinvest-store-frontend';
import { ACCOUNT_API_NAMES } from './apis';

export const fetchHoldings = (accountNo: AccountKey) => {
  return async (dispatch: Dispatch<any>, getState: () => IStore) => {
    const hash = getState()[ACCOUNT_STORE_NAME].holdings[accountNo]?.hash ?? 0;
    const request: Partial<CmcWebApi.Account.AccountHoldingsLeanRequest2> & IWebApiRequestBody = {
      AccountNumbers: [accountNo],
      Hash: hash
    };

    try {
      const response = await frontendActions.webTradingApiCall<
        Omit<CmcWebApi.Account.AccountHoldingsLeanModel2, 'Holdings'> & { Holdings: CmcWebApiAccountHoldingLeanModel1[] }
      >(ACCOUNT_STORE_NAME, ACCOUNT_API_NAMES.AccountHoldingsLeanGet2, request, dispatch, accountNo, false, true);
      if (hash !== response.Hash) {
        dispatch(actions.holdingsFetched({ accountNo, hash: response.Hash, holdings: response.Holdings }));
      }
    } catch {}
  };
};

export const onPollHoldings =
  (subscriptions: ResourceKey[] = []) =>
  (dispatch: Dispatch<any>) => {
    subscriptions.forEach((sub) => {
      dispatch<any>(fetchHoldings(sub as AccountKey));
    });
  };

export const subscribeHoldings = (location: LocationType, accountNo: AccountKey) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.subscribe({
      onPoll: onPollHoldings,
      location,
      apiName: ACCOUNT_API_NAMES.AccountHoldingsLeanGet2,
      storeName: ACCOUNT_STORE_NAME,
      resourceKeys: [accountNo],
      pollTimeout: getConfig().pollTimeout
    })
  );
};

export const unsubscribeHoldings = (location: LocationType, accountNo: AccountKey) => (dispatch: Dispatch<any>) => {
  dispatch<any>(
    frontendActions.unsubscribe({
      location,
      apiName: ACCOUNT_API_NAMES.AccountHoldingsLeanGet2,
      storeName: ACCOUNT_STORE_NAME,
      resourceKeys: [accountNo]
    })
  );
};
